<app-form-custrights
    [groupList]="groupList"
    [userList]="userList"
    [screenList]="screenList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-custrights>

